<template>
    <v-container fluid>
        <v-flex class="show-speakers">
            <h4>{{SpeakerApplicants.SHOW_SPEAKERS_WHO_ARE}}</h4>
            <v-flex pb-3>
                <!-- <v-flex pr-2 class="show-speakers__list">
                    <label>Member Type</label>
                    <v-flex xs12 class="member-type">
                        <v-checkbox
                        label="Members (28,545)"
                        color="primary"
                        value="primary"
                        hide-details
                    ></v-checkbox>
                    <v-checkbox
                        label="Grandfathered (Chapter Only)(2,731)"
                        color="primary"
                        value="primary"
                        hide-details
                    ></v-checkbox>
                    <v-checkbox
                        label="Spouse/Partners (25,013)"
                        color="primary"
                        value="primary"
                        hide-details
                    ></v-checkbox>
                    <v-checkbox
                        label="Chapter Administrators (410)"
                        color="primary"
                        value="primary"
                        hide-details
                    ></v-checkbox>
                    <v-checkbox
                        label="YPO Management Associate (608)"
                        color="primary"
                        value="primary"
                        hide-details
                    ></v-checkbox>
                    <v-checkbox
                        label="Non-Members"
                        color="primary"
                        value="primary"
                        hide-details
                    ></v-checkbox>
                    </v-flex>
                </v-flex> -->
                <v-flex class="show-speakers__list">
                    <label>{{SpeakerApplicants.MEMBERS}}</label>
                    <v-switch
                        color="primary"
                        value="Member"
                        hide-details
                        inset
                        v-model="speakersWhoAre"
                        @change="onFilterChange"></v-switch>
                </v-flex>
                <v-flex class="show-speakers__list">
                    <label>{{SpeakerApplicants.AVAILABLE_ONLINE}}</label>
                    <v-switch
                        color="primary"
                        value="AvailableVirtually"
                        hide-details
                        inset
                        v-model="speakersWhoAre"
                        @change="onFilterChange"></v-switch>
                </v-flex>
                <v-flex class="show-speakers__list interested-trp">
                    <label>{{SpeakerApplicants.TRP_PROGRAM}} <i @mouseover="showTooltipForInterested = true" @mouseout="showTooltipForInterested = false" class="fas fa-info-circle">
                        </i></label>
                    <v-flex v-if="showTooltipForInterested" class="find-speaker-tooltip">
                        <span>{{SpeakerApplicants.INTERESTED_IN_THE_TRP}}
                        </span>
                    </v-flex>
                    <v-switch
                        color="primary"
                        value="InTRPProgram"
                        hide-details
                        inset
                        v-model="speakersWhoAre"
                        @change="onFilterChange"></v-switch>
                </v-flex>
                <v-flex class="show-speakers__list">
                    <label>{{SpeakerApplicants.YPO_REFERRED}}</label>
                    <v-switch
                        color="primary"
                        value="ReferredByYPOMembers"
                        hide-details
                        inset
                        v-model="speakersWhoAre"
                        @change="onFilterChange"></v-switch>
                </v-flex>
                <v-flex class="show-speakers__list">
                    <label>{{SpeakerApplicants.PREVIOUS_SPEAKER_AT_YPO}}</label>
                    <v-switch
                        color="primary"
                        value="SpeakersAtPreviousYPOEvents"
                        hide-details
                        inset
                        v-model="speakersWhoAre"
                        @change="onFilterChange"></v-switch>
                </v-flex>
                <v-flex class="show-speakers__list">
                    <label>{{SpeakerApplicants.FEE_NEGOTIATION}}</label>
                    <v-switch
                        color="primary"
                        inset
                        value="NegotiateFee"
                        hide-details
                        v-model="speakersWhoAre"
                        @change="onFilterChange"></v-switch>
                </v-flex>
            </v-flex>
        </v-flex>

    </v-container>
</template>

<script>
    import { SpeakerApplicants } from "../Speakers/speakerConstant";

    export default {
        name: "SearchSpeakersWhoAre",
        data: () => ({
            SpeakerApplicants,
            showTooltipForInterested: false,
            speakersWhoAre: [],
        }),
        props: {
            applySpeakerFilter: {
                type: Function,
                required: true,
            },
        },
        created() {
            this.checkSpeakersWhoAreFilters();
        },
        methods: {
            onFilterChange() {
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        speakersWhoAre: this.speakersWhoAre.join('~'),
                    },
                });
            },
            checkSpeakersWhoAreFilters(value = this.$route.query.speakersWhoAre) {
                if (value && value.length) {
                    value = value.split('~');
                    this.speakersWhoAre = value;
                    this.applySpeakerFilter(value.map(item => ({
                        label: item,
                        filterKey: item,
                        filterValue: true,
                    })));
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";
</style>
